import BusinessContext from "Context/BusinessContext";
import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { v4 } from "uuid";
import UserContext from "../../Context/UserProvider";
import { NotificationContext } from "../../components/common/Notifications/NotificationProvider";
import HourHeatMap from "../../components/fleet/HeatMap/HourHeatMap";
import { useApiService } from "../../services/ApiService/ApiService";

function DwellingDetailPage(props: any) {
  const [hourHeatMapData, setHourHeatMapData] = useState([]) as any;
  const [selectWeekData, setSelectWeekData] = useContext(BusinessContext) as any;
  const notificationContext = useContext(NotificationContext);
  const [loading, setLoading] = useState(true);
  const [selectedWeek, setSelectedWeek] = useState([]) as any;
  const [daysLabels, setDayLabels] = useState([]) as any;
  const [selectGeoLocation, setSelectGeoLocation] = useState("") as any;
  const location = useLocation();
  const [selectedLocationDwelling] = useState() as any;
  const params: any = location.state;
  const {userInfo} = useContext(UserContext);
  const { fetchWithAuth } = useApiService();
  const [activeMenu, setActiveMenu] = useState(selectWeekData ? selectWeekData.weekNumber : 0);

  async function getGeoCode(fleetDwelling: any) {
    let bodyData: { [name: string]: string } = {};
    bodyData["uuid"] = userInfo.uuid;
    bodyData["fleetUuid"] = userInfo.fleetUuid;
    bodyData["fleetDwelling"] = fleetDwelling;

    try {
      const response = await fetchWithAuth('/infrastructure/dwelling/address/geocode', {
        method: 'POST',
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        throw new Error('Failed to geocode address');
      }

      const res_json = await response.json();
      setSelectGeoLocation(res_json.addressLine);
    } catch (error) {
      console.error('Error geocoding address:', error);
    }
  }

  async function updateLocation(fleetDwelling: any) {
    let bodyData: { [name: string]: string } = {};
    let dwellingID = params.value.uuid;
    fleetDwelling = { ...fleetDwelling, uuid: dwellingID };
    bodyData["uuid"] = userInfo.uuid;
    bodyData["fleetUuid"] = userInfo.fleetUuid;
    bodyData["fleetDwelling"] = fleetDwelling;

    try {
      const response = await fetchWithAuth('/infrastructure/dwelling/update', {
        method: 'POST',
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        throw new Error('Failed to update location');
      }

      const res_json = await response.json();
      notificationContext.dispatch({
        type: "ADD_NOTIFICATION",
        payload: {
          id: v4(),
          type: "SUCCESS",
          message: `Dwelling of address ${params.value.addressLine} has been changed to ${selectGeoLocation}`,
        },
      });
      params.value = {
        ...params.value,
        centreLatitude: fleetDwelling.centreLatitude,
        centreLongitude: fleetDwelling.centreLongitude,
        addressLine: selectGeoLocation,
      };
    } catch (error) {
      console.error('Error updating location:', error);
    }
  }

  function fetchHourHeatMapData() {
    setLoading(true);
    let bodyData: { [name: string]: string } = {};
    bodyData["uuid"] = userInfo.uuid;
    bodyData["businessUuid"] = userInfo.businessUuid;
    bodyData["fleetDwellingUuid"] = params.fleetDwellingUuid;
    bodyData["operationalCostModelUuid"] = params.operationalCostModelUuid;
    bodyData["startDayKey"] = params.startDayKey;
    bodyData["fleetSnapshotDwellingUuid"] = params.fleetSnapshotDwellingUuid;

    fetchWithAuth('/infrastructure/dwelling/detail/get', {
      method: 'POST',
      body: JSON.stringify(bodyData),
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Failed to fetch heat map data');
      }
      return response.json();
    })
    .then(res_obj => {
      setHourHeatMapData(res_obj.heatMap);

      const data_heat = res_obj.heatMap[Object.keys(res_obj.heatMap)[0]].days.map((e: any) => {
        return e.hours.map((e: any) => ({
          kw: e.kw,
          vehicleCount: e.vehicleCount,
        }));
      });
      const day_labels = res_obj.heatMap[Object.keys(res_obj.heatMap)[0]].daysOfWeek;
      setSelectedWeek(data_heat);
      setDayLabels(day_labels);
      setSelectWeekData({ 
        dateOfWeek: Object.keys(res_obj.heatMap)[0], 
        weekNumber: 0, 
        dwellingUuid: params.fleetDwellingUuid, 
        operationalCostModelUuid: params.operationalCostModelUuid, 
        startDayKey: params.startDayKey, 
        fleetSnapshotDwellingUuid: params.fleetSnapshotDwellingUuid 
      });
    })
    .catch(error => {
      console.error('Error fetching heat map data:', error);
    })
    .finally(() => {
      setLoading(false);
    });
  }

  useEffect(() => {
    selectedLocationDwelling && getGeoCode(selectedLocationDwelling);
  }, [selectedLocationDwelling]);

  useEffect(() => {
    console.log("init");
    fetchHourHeatMapData();
  }, []);

  return (
    <div className="d-flex flex-column gap-5">

      {loading ? (
        <>Loading ...</>
      ) : (
        <>
          <h1>Dwelling Time Heatmap</h1>
          <div style={{ display: "flex", gap: "10px", fontWeight: "bold" }}>
            {Object.keys(hourHeatMapData).map((key, i) => {
              return (
                <div
                  key={i}
                  style={{ display: "flex", gap: 10 }}>
                  <div className="vl"></div>
                  <button
                    className={`tab-btn ${activeMenu === i ? "active" : ""}`}
                    style={{
                      border: 'none',
                      borderRadius: 24,
                      padding: '10px 24px',
                      background: activeMenu === i ? '#1976d2' : '#f5f5f5',
                      color: activeMenu === i ? '#fff' : '#333',
                      fontWeight: 600,
                      fontSize: '1rem',
                      boxShadow: activeMenu === i ? '0 2px 8px rgba(25, 118, 210, 0.15)' : 'none',
                      transition: 'all 0.2s',
                      cursor: 'pointer',
                      outline: 'none',
                      minWidth: 120,
                      whiteSpace: 'nowrap',
                    }}
                    onMouseOver={e => e.currentTarget.style.background = activeMenu === i ? '#1565c0' : '#e3e3e3'}
                    onMouseOut={e => e.currentTarget.style.background = activeMenu === i ? '#1976d2' : '#f5f5f5'}
                    onClick={() => (
                      setSelectedWeek(
                        hourHeatMapData[key].days.map((e: any) => {
                          return e.hours.map((e: any) => ({
                            kw: e.kw,
                            vehicleCount: e.vehicleCount,
                          }));
                        })
                      ),
                      setSelectWeekData((prev: any) => ({ ...prev, dateOfWeek: key, weekNumber: i })),
                      setActiveMenu(i),
                      setDayLabels(hourHeatMapData[key].daysOfWeek)
                    )}>
                    {`${hourHeatMapData[key].days[0].day} | ${hourHeatMapData[key].days[0].weekCommencing}`}
                  </button>
                </div>
              );
            })}
            <div className="vl"></div>
          </div>

          <HourHeatMap data={selectedWeek} labels={daysLabels}/>
        </>
      )}
    </div>
  );
}

export default DwellingDetailPage;
